<template>
  <Modal
    v-model="showModal"
    :title="title"
    :closable="closable"
    :mask-closable="maskClosable"
    :mask="mask"
    :width="width"
    :footer-hide="footerHide"
    :styles="styles"
    :class-name="className"
    :transform="transform"
    :class="{'hide-header-line': hideHeaderLine}"
    class="modal-custom"
    @on-ok="onOkDefault"
    @on-cancel="onCancelDefault"
  >
    <div class="body">
      <slot name="body">
        <p>Modal内容</p>
      </slot>
    </div>
    <ModalButtons
      :need-button="needButton"
      :button-position="buttonPosition"
      :ok-show="okShow"
      :ok-text="okText"
      :ok-class="okClass"
      :ok-loading="okLoading"
      :ok-disabled="okDisabled"
      :cancel-show="cancelShow"
      :cancel-text="cancelText"
      :cancel-class="cancelClass"
      :cancel-loading="cancelLoading"
      :cancel-disabled="cancelDisabled"
      @on-ok="onOk"
      @on-cancel="onCancel"
    ></ModalButtons>
  </Modal>
</template>

<script>
/**
 * 自定义Modal，gip项目统一使用该Modal，统一样式
 * 包含大，中，小3种modal
 * button 已添加布局样式，只需添加按钮样式。即: btn-fill-34, width-100 等
 */
  import ModalButtons from './modal-buttons'
  export default {
    name: 'ModalCustom',
    components: {
      ModalButtons
    },
    props: {
      model: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: '温馨提示'
      },
      // 右上角关闭按钮
      closable: {
        type: Boolean,
        default: true
      },
      // 点击遮罩层关闭
      maskClosable: {
        type: Boolean,
        default: false
      },
      // 是否显示遮罩层
      mask: {
        type: Boolean,
        default: true
      },
      width: {
        type: [Number, String],
        default: 480
      },
      // 隐藏底部
      footerHide: {
        type: Boolean,
        default: true
      },
      // 设置Modal 样式: .ivu-modal
      styles: {
        type: Object,
        default: function () {
          return {}
        }
      },
      // 设置容器类名: .ivu-modal-wrap 类名
      className: {
        type: String,
        default: 'vertical-100-modal'
      },
      transform: {
        type: Boolean,
        default: true
      },
      // 隐藏 header.bottom.border
      hideHeaderLine: {
        type: Boolean,
        default: false
      },
      // 按钮相关
      needButton: {
        type: Boolean,
        default: true
      },
      buttonPosition: {
        type: String,
        validator: function (value) {
          return ['center', 'right'].includes(value)
        },
        default: 'right'
      },
      okText: {
        type: String,
        default: '确定'
      },
      okClass: {
        type: String,
        default: 'btn-fill-34'
      },
      okLoading: {
        type: Boolean,
        default: false
      },
      okDisabled: {
        type: Boolean,
        default: false
      },
      okShow: {
        type: Boolean,
        default: true
      },
      cancelText: {
        type: String,
        default: '取消'
      },
      cancelClass: {
        type: String,
        default: 'btn-border-34'
      },
      cancelLoading: {
        type: Boolean,
        default: false
      },
      cancelDisabled: {
        type: Boolean,
        default: false
      },
      cancelShow: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        showModal: false
      }
    },
    mounted () {
    },
    methods: {
      modelChanged (model) {
        this.showModal = model
      },
      onCancel () {
        this.$emit('on-cancel')
      },
      onOk () {
        this.$emit('on-ok')
      },
      // modal 自带ok 事件: ok
      onOkDefault () {
        this.$emit('on-ok-default')
      },
      // modal 自带cancel 事件: cancel、右上角x、遮罩层关闭
      onCancelDefault () {
        this.$emit('on-cancel-default')
      }
    },
    computed: {},
    watch: {
      model: {
        handler: 'modelChanged',
        immediate: true
      },
      showModal () {
        if (!this.showModal) {
          this.onCancel()
        }
      }
    }
  }
</script>

<style lang="less" scoped>

  .modal-custom {
    .body {
      width: 100%;
      min-height: 48px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/components/modal-custom/modal-custom.vue